module.exports = __webpack_public_path__ + "static/media/ic_mask_stop.1ce25c65.svg";